<template>
  <div id="app"  data-app class="d-flex flex-column flex-root">
    <router-view></router-view>
    <!-- set progressbar -->
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";

// Main demo style scss
@import "assets/sass/style.vue";

// Check documentation for RTL css
/*@import "assets/css/style.vue.rtl";*/
</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import { mapGetters } from "vuex";

export default {
  name: "MetronicVue",
  metaInfo() {
        return { 
            title: "Mi Bricsa",
            meta: [
                { name: 'description', content:  'Mi Bricsa. Accede a toda la información que tenemos para tí'},
                { property: 'og:title', content: "Mi Bricsa"},
                { property: 'og:site_name', content: 'Mi Bricsa'},
                {property: 'og:type', content: 'website'},    
                {property: 'og:description', content: 'Mi Bricsa. Accede a toda la información que tenemos para tí'},
                {property: 'og:image:width', content: '600'},
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    },
  mounted() {
    window.onbeforeunload = function () {
      
    };
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);

    // Set background image
    const bg = this.layoutConfig("self.body.background-image");
    document.body.style.backgroundImage = `url('${bg}')`;
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  }
};
</script>
